export const M = 1;
export const T = 2;
export const W = 3;
export const R = 4;
export const F = 5;
